import { AbstractControl, ValidatorFn } from '@angular/forms';

import { EMAIL_REGEXP } from '@shared/constants/email.regexp.const';

export const EmailPatternValidator = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } => {
    return EMAIL_REGEXP.test(control?.value) ? null : { email: true };
  };
};
